import type { CategorySummary } from '@quds/shared';
import { apiGet } from '@/lib/api';

export type { CategorySummary };

/** Categories with the number of Central Admin business records (not production customers). */
export async function listCategorySummaries(): Promise<CategorySummary[]> {
  return (await apiGet<{ items: CategorySummary[] }>('/categories')).items;
}
